import { has } from 'es-toolkit/compat';
export function safeBooleanProps(props, propNames) {
  propNames.forEach(function (name) {
    if (has(props, name) && (props[name] === 'true' || props[name] === 'false')) {
      props[name] = props[name] === 'true';
    }
  });
}